/** The actual Save/Discard button children, shared by native Save Bar and the local control preview. */
import { shopifyComponentCopy } from '@testfeed/product-language'
import type { UnifiedStudySetupPanelBuilder } from './UnifiedStudySetupPanel'
type EditingControls = Pick<
  UnifiedStudySetupPanelBuilder,
  'isDirty' | 'lifecycle' | 'handleSaveDraft' | 'handleDiscard'
>

export function StudyBuilderDraftActions({ builder }: { builder: EditingControls }) {
  const save = builder.lifecycle.button('save-draft')
  const discard = builder.lifecycle.button('discard')
  const copy = shopifyComponentCopy.studyBuilderPanel
  return (
    <>
      <button
        type="button"
        {...{ variant: 'primary', loading: save.loading ? '' : undefined }}
        disabled={save.disabled || save.loading}
        onClick={() => {
          void builder.handleSaveDraft()
        }}
      >
        {copy.save004}
      </button>
      <button
        type="button"
        {...{ loading: discard.loading ? '' : undefined }}
        disabled={discard.disabled || discard.loading}
        onClick={() => {
          void builder.handleDiscard()
        }}
      >
        {copy.discard006}
      </button>
    </>
  )
}
